import React from 'react';
import { Accordion } from 'react-bootstrap';
import LinksTable from './LinksTable';
import { useTranslation } from 'react-i18next';

interface Row {
  link_type: 'open' | 'closed';
  zone_name: string;
  window_name: string;
  offset_type: 'before' | 'after' | 'on';
  offset_days: number;
}

interface Props {
  links: Row[];
  setLinks: (rows: Row[]) => void;
  zones: any[];
  schedulingWindows: any[];
  forbiddenLinkWindowIds?: Set<number>;
}

const LinksSection: React.FC<Props> = ({ links, setLinks, zones, schedulingWindows, forbiddenLinkWindowIds }) => {
  const { t } = useTranslation();

  const addRow = () =>
    setLinks([
      ...links,
      {
        link_type: 'open',
        zone_name: '',
        window_name: '',
        offset_type: 'on',
        offset_days: 0,
      },
    ]);

  const changeRow = (i: number, patch: Partial<Row>) => {
    const next = [...links];
    next[i] = { ...next[i], ...patch };
    setLinks(next);
  };

  const deleteRow = (i: number) => setLinks(links.filter((_, idx) => idx !== i));

  return (
    <Accordion defaultActiveKey="2" className="mb-3">
      <Accordion.Item eventKey="2">
        <Accordion.Header>{t('Links (Enabled/Disabled)')}</Accordion.Header>
        <Accordion.Body>
          <LinksTable
            rows={links}
            onAddRow={addRow}
            onChangeRow={changeRow}
            onDeleteRow={deleteRow}
            zones={zones}
            schedulingWindows={schedulingWindows}
            forbiddenLinkWindowIds={forbiddenLinkWindowIds}
          />
          <div className="text-muted small">
            <strong>Enabled</strong> rows submit as <code>references</code>; <strong>Disabled</strong> as <code>exclusions</code>.
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default LinksSection;
